<template>
    <div>
        <van-tabs v-if="isshow" v-model="active"  @change="change">
            <van-tab>
                <div class="title" slot="title">
                    <div class="text">
                        参与活动
                        <div class="infos" v-if="relaCnt && relaCnt.campaignCnt>0">{{ relaCnt.campaignCnt }}</div>
                    </div>
                </div>
                <JnActivity  :custId="this.custId"  ref="JnActivity" />
            </van-tab>
            <van-tab>
                <div class="title" slot="title">
                    <div class="text">
                        参与课程
                        <div class="infos" v-if="relaCnt && relaCnt.courseCnt>0"> {{  relaCnt.courseCnt }}</div>
                    </div>
                </div>
                <JnCurriculum  :custId="this.custId"  ref="JnCurriculum" />
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import JnActivity from "./joinActivity.vue"; //参与活动
import JnCurriculum from "./joinCurriculum.vue"; //参与课程
export default {
    name: "joinTab",
    components: {
        JnActivity,
        JnCurriculum,
    },
    props: {
        custId: String, // 限制 name 的属性值为 string 类型
        relaCnt: Object,
        isshow:Boolean,
    },
    data() {
        return {
            active:0,
        };
    },
    methods: {
        change(a,b){
        },
        laodData(newVal){
            if(newVal==0){
                this.$nextTick(function() {
                    this.$refs.JnActivity.joinActivityList(this.custId);
                });
            }else if(newVal==1){
                this.$nextTick(function() {
                    this.$refs.JnCurriculum.joinCurriculumList(this.custId);
                });
            }
        }
    },
    watch:{
        active:{
            handler(newVal,oldVal) {
                console.log('active',newVal)
                this.laodData(newVal)
            },
            immediate: false
        },
        isshow:{
            handler(newVal,oldVal) {
                if(newVal===true){
                    this.laodData(this.active)
                }
            }
        }
    },
    mounted() {

    },
    created() {}
  };
  </script>

  <style lang="less" scoped>
    .text{
        position: relative;
        display: inline-block;
    }
    .infos{
            display: inline-block;
            // min-width: 10px;
            // height:10px;
            // line-height: 10px;
            background: red;
            color: #fff;
            border-radius: 50%;
            text-align: center;
            font-size: 12px;
            max-width: 1rem;
            max-height: 1rem;
            line-height: 1.25;
            padding: 0rem 0.1rem;
        }
  </style>


// WEBPACK FOOTER //
// src/components/client/childCompoents/joinTab.vue